<template>
	<div v-if="isBreakerScan" id="app" class="breaker-guide">
		<div class="breaker-guide-panel">
			<div class="breaker-guide-badge">包厢断路器开门码</div>
			<div class="breaker-guide-title">请使用飞社 APP 扫码开门</div>
			<div class="breaker-guide-subtitle">当前二维码用于包厢断路器开门，请在飞社 APP 内扫码完成订单校验。</div>
			<div class="breaker-guide-actions">
				<div class="joinBtn" @click="openApp()">打开 APP 扫码</div>
				<div class="downloadBtn" @click="downloadApp()">下载 APP</div>
			</div>
		</div>
	</div>
	<div v-else id="app" :style="{ backgroundImage: `url(${shareBackgroundUrl})` }">
		<div class="title">{{title}}</div>
		<div class="user-info">
			<div class="face">
				<img class="img"
					:src="shareUserAvatar ? getUrl(shareUserAvatar) : require('@/assets/face.png')"
					alt="" srcset="" />
			</div>
			<div class="name">{{shareUserName}}</div>
		</div>
		<div class="qrcode" v-if="isDoor">
			<img :src="getUrl(dataInfo.shareQrcode)" class="img" alt="">
		</div>
		
		<div v-if="!isDoor" class="formwrap">
			<input @change="handlePhoneChange" @input="handlePhoneInput" v-model="phoneNumber" type="tel" inputmode="numeric" pattern="[0-9]*" maxlength="11" class="phoneInput"
				placeholder="请输入您的手机号" />
			<div class="joinBtn" @click="join()">立即加入</div>
		</div>
	</div>
</template>

<script>
	// import HelloWorld from './components/HelloWorld.vue'
	import {
		Dialog,
		Toast,
	} from 'vant';
	import request from '@/utils/request'

	export default {
		name: 'App',
		components: {
			// HelloWorld
		},
		data() {
			return {
				phoneNumber: '',
				phoneError: false,
				dataInfo:{},
				baseURL: process.env.VUE_APP_FILE_CDN || process.env.VUE_APP_API,
				shareBackgroundUrl: `${process.env.VUE_APP_FILE_CDN || process.env.VUE_APP_API}/share/background.png`,
				isBreakerScan:false,
				title:'',
				isDoor:false,//是否是门禁
			}
		},
		created() {
			
			this.isBreakerScan = window.location.pathname.replace(/\/$/, '') === '/breaker/scan'
			if (this.isBreakerScan) {
				return
			}
			const promoterId = Number(this.getQueryParam('p') || this.getQueryParam('promoterId') || 0)
			if (Number.isFinite(promoterId) && promoterId > 0) {
				this.dataInfo = { userId: promoterId }
				this.title = '邀请你加入flysoci'
				this.fetchPromotionProfile(promoterId)
				return
			}
			
			console.log(this.getQueryParam("s"))
			if (this.getQueryParam("s")) {
				// localStorage.setItem("token", this.getQueryParam("token"))
				this.fetchData()
			} else {
				console.log('111111111')
			}
		},

		computed: {
			shareUserAvatar() {
				return this.dataInfo.userAvatar || this.dataInfo.avatar || (this.dataInfo.user && this.dataInfo.user.avatar) || ''
			},
			shareUserName() {
				return this.dataInfo.userName || this.dataInfo.nickName || (this.dataInfo.user && this.dataInfo.user.nickName) || '飞社好友'
			}
		},

		methods: {
			async fetchPromotionProfile(promoterId) {
				try {
					const res = await request.get('/app/fsPromotion/publicInfo', {
						params: { promoterId },
						skipToken: true
					})
					if (res && res.code === 200 && res.data) {
						this.dataInfo = Object.assign({}, this.dataInfo, res.data)
					}
				} catch (error) {
					console.error('获取推广人资料失败', error)
				}
			},
			async fetchData() {
				try {
					const res = await request.get('/app/share/str/'+this.getQueryParam("s"), { skipToken: true })
					console.log(res.data)
					this.dataInfo = res.data
					console.log(this.dataInfo.shareQrcode)
					if(this.dataInfo.shareQrcode){
						
						this.title = '临时门禁码'
						this.isDoor = true
					} else {
						this.title = '邀请好友'
						this.isDoor = false
					}
					
				} catch (error) {
					console.error(error)
				}
			},
			
			getUrl(link){
				if (!link) return ''
				if(link.indexOf('http://')== 0 || link.indexOf('https://')== 0){
					return link
				} else {
					return this.baseURL + (link.indexOf('/') === 0 ? link : '/' + link)
				}
			},
			
			
			getQueryParam(name) {
				// 获取URL中的查询字符串部分（包含?）
				const urlParams = new URLSearchParams(window.location.search);
				// 使用URLSearchParams的get方法获取指定参数的值
				return urlParams.get(name) || null;
			},
			handlePhoneChange() {
				console.log(this.phoneNumber)
				// 手机号格式验证


				// if(this.phoneNumber.length == 11){
				// 	this.phoneError = false
				// } else {


				// 	this.phoneError = false
				// 	!phoneRegex.test(this.phoneNumber)
				// }


				// this.phoneError = !phoneRegex.test(this.phoneNumber)
			},
			handlePhoneInput() {
				this.phoneNumber = String(this.phoneNumber || '').replace(/\D/g, '').slice(0, 11)
			},
			openApp() {
				window.location.href = 'hbuilder://pages/index/index'
			},
			downloadApp() {
				window.location.href = 'https://share.flysoci.com'
			},

			async join() {
				// window.location.href = 'hbuilder://pages/user?aa=1'
				
				// return
				const phoneRegex = /^1[3-9]\d{9}$/;
				if (phoneRegex.test(this.phoneNumber)) {
					var res = await request.post('/app/fsPromotion/inviteByPhone',{
						promoterId:this.dataInfo.userId,
						refereePhone:this.phoneNumber
					}, { skipToken: true })
					console.log(res)
					
					if(res.code == 200){
						Dialog.confirm({
							message: res.msg,
							confirmButtonText: '打开APP',
						}).then(()=>{
							console.log('确定')
							try{
								window.location.href = 'hbuilder://pages/user'
							} catch(e){
								console.log('catch',e)
							}
							
						}).catch(() => {
							
							
							// on cancel
						});
					} else {
						Toast(res.msg);
					}
					
					// window.location.href
					// Toast('正确');
				} else {
					Toast('请输入正确的手机号');
				}


			}
		}
	}
</script>

<style>
	* {
		padding: 0;
		margin: 0;
	}

	html,body {
		width: 100%;
		height: 100%;
	}
	
	.shadow{
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 10;
		background: rgba(0,0,0,0.6);
		left: 0;
		top: 0;	
	}
	
	
	.shadow .arrow{
		width: 200px;
		height: 200px;
		background: url(data:image/png;base64,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);
		background-size: 100% 100%;
		position: absolute;
		right: 0px;
		top: 30px;
	}
	
	.shadow .notice-list{
		width: 100%;
		position: absolute;
		left: 0;
		top: 300px;
		
		
	}
	
	.shadow .notice-list .notice{
		text-align: center;
		font-size: 32px;
		color: #ffffff;
		line-height: 50px;
	}

	#app {
		width: 750px;
		height: 100%;
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.title {
		width: 100%;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 32px;
		line-height: 44px;
		color: #FFFFFF;
		text-align: center;
		font-style: normal;
		text-transform: none;
		padding-top: 12px;
	}

	.formwrap {
		width: 100%;
		box-sizing: border-box;
		position: absolute;
		bottom: 60px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
	
	
	.phoneInput {
		width: 375px;
		height: 100px;
		border-radius: 50px;
		padding: 0 40px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 28px;
		color: #333333;
		text-align: left;
		border: 0;
		outline: none;
		margin-bottom: 24px;
	}
	
	.phoneInput::placeholder {
		color: #9C9C9C;
	}
	
	
	.joinBtn {
		width: 375px;
		height: 82px;
		text-align: center;
		line-height: 82px;
		background: #00CE91;
		border-radius: 41px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 32px;
		color: #FFFFFF;
		
	}

	.user-info {
		padding: 0 44px;
		height: 106px;
		width: 100%;
		box-sizing: border-box;
		display: flex;
		align-items: center;

		
	}
	
	.user-info .face {
		width: 106px;
		height: 106px;
		background: #ffffff;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		box-sizing: border-box;
		border: 4px solid #ffffff;
		margin-right: 14px;
	
		
	}
	
	.user-info .face .img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
	
	
	.user-info .name {
		font-family: PingFang SC, PingFang SC;
		font-weight: bold;
		font-size: 32px;
		color: #FFFFFF;
		text-align: left;
	}
	
	.qrcode{
		width: 382px;
		height: 382px;
		box-sizing: border-box;
		padding: 20px;
		background: #ffffff;
		margin: 0 auto;
		margin-top: 32px;
		border-radius: 24px;
	}
	
	.qrcode .img{
		width: 402px;
		height: 402px;
	}

	.breaker-guide {
		min-height: 100%;
		background: linear-gradient(180deg, #f5f7fb 0%, #ffffff 100%);
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 40px 24px;
		box-sizing: border-box;
	}

	.breaker-guide-panel {
		width: 100%;
		max-width: 560px;
		text-align: center;
	}

	.breaker-guide-badge {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		height: 32px;
		padding: 0 14px;
		border-radius: 16px;
		background: #ecf5ff;
		color: #1677ff;
		font-size: 14px;
		margin-bottom: 18px;
	}

	.breaker-guide-title {
		font-size: 34px;
		line-height: 44px;
		font-weight: 700;
		color: #1f2d3d;
	}

	.breaker-guide-subtitle {
		margin-top: 18px;
		font-size: 18px;
		line-height: 30px;
		color: #606266;
	}

	.breaker-guide-actions {
		margin-top: 34px;
		display: flex;
		gap: 16px;
		justify-content: center;
	}

	.breaker-guide-steps {
		margin-top: 28px;
		display: grid;
		gap: 10px;
		text-align: left;
	}

	.breaker-guide-step {
		padding: 12px 14px;
		border-radius: 8px;
		background: #fff;
		color: #303133;
		font-size: 15px;
		box-shadow: 0 6px 18px rgba(31, 45, 61, 0.06);
	}

	.breaker-wechat-mask {
		position: fixed;
		inset: 0;
		z-index: 20;
		pointer-events: none;
		background: rgba(0, 0, 0, 0.58);
	}

	.breaker-wechat-arrow {
		position: absolute;
		top: 16px;
		right: 24px;
		width: 82px;
		height: 82px;
		border-top: 4px solid #fff;
		border-right: 4px solid #fff;
		border-radius: 0 18px 0 0;
	}

	.breaker-wechat-card {
		position: absolute;
		top: 116px;
		left: 22px;
		right: 22px;
		padding: 18px;
		border-radius: 10px;
		background: #fff;
		text-align: left;
		color: #303133;
	}

	.breaker-wechat-title {
		font-size: 20px;
		line-height: 28px;
		font-weight: 700;
	}

	.breaker-wechat-text {
		margin-top: 8px;
		font-size: 15px;
		line-height: 24px;
		color: #606266;
	}

	.downloadBtn {
		height: 46px;
		min-width: 132px;
		padding: 0 24px;
		border: 1px solid #dcdfe6;
		border-radius: 23px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #303133;
		background: #ffffff;
		font-size: 16px;
	}
	
	
</style>
